import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.734 5.926V3.8C11.734 1.704 10.059 0 8 0 5.942 0 4.266 1.704 4.266 3.8v2.126A3.04 3.04 0 0 0 2.4 8.74v3.421c0 1.677 1.34 3.04 2.987 3.04h5.227c1.647 0 2.986-1.363 2.986-3.04V8.74a3.04 3.04 0 0 0-1.866-2.814M8.457 11.4h-.914l-.476-2.85h1.866zm1.783-5.7H5.76V3.8c0-1.257 1.006-2.28 2.24-2.28 1.236 0 2.24 1.023 2.24 2.28z"
    }, null, -1)
  ])))
}
export default { render: render }